module.exports = __webpack_public_path__ + "img/purple_light.8300002.svg";